module.exports = __webpack_public_path__ + "img/101-northern-cyprus.c7c7ae0a.svg";